/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type SocialMediaPlatformKind = "ANGEL_LIST" | "FACEBOOK" | "INSTAGRAM" | "LINKED_IN" | "MEDIUM" | "OTHER" | "PINTEREST" | "REDDIT" | "SNAPCHAT" | "TUMBLR" | "TWITTER" | "WEIBO" | "WHATS_APP" | "YOU_TUBE" | "%future added value";
export type matrixPanelQueryVariables = {
    readonly id: string;
};
export type matrixPanelQueryResponse = {
    readonly list: {
        readonly hasErrors: boolean | null;
        readonly list: ({
            readonly id?: string;
            readonly title?: string | null;
            readonly name?: string | null;
            readonly description?: string | null;
            readonly items?: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly __typename: string;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly fullName?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly socialMediaProfiles?: ReadonlyArray<{
                                readonly id: string;
                                readonly link: string | null;
                                readonly platform: {
                                    readonly id: string;
                                    readonly kind: SocialMediaPlatformKind | null;
                                } | null;
                            }> | null;
                            readonly previews?: {
                                readonly edges: ReadonlyArray<{
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly responsibility?: string | null;
                            readonly description?: string | null;
                        } & ({
                            readonly __typename: "Person";
                            readonly id: string;
                            readonly fullName: string | null;
                            readonly landingPageUrl: string | null;
                            readonly socialMediaProfiles: ReadonlyArray<{
                                readonly id: string;
                                readonly link: string | null;
                                readonly platform: {
                                    readonly id: string;
                                    readonly kind: SocialMediaPlatformKind | null;
                                } | null;
                            }> | null;
                            readonly previews: {
                                readonly edges: ReadonlyArray<{
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly responsibility: string | null;
                            readonly description: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } & ({
            readonly id: string;
            readonly title: string | null;
            readonly name: string | null;
            readonly description: string | null;
            readonly items: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly __typename: string;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly fullName?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly socialMediaProfiles?: ReadonlyArray<{
                                readonly id: string;
                                readonly link: string | null;
                                readonly platform: {
                                    readonly id: string;
                                    readonly kind: SocialMediaPlatformKind | null;
                                } | null;
                            }> | null;
                            readonly previews?: {
                                readonly edges: ReadonlyArray<{
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly responsibility?: string | null;
                            readonly description?: string | null;
                        } & ({
                            readonly __typename: "Person";
                            readonly id: string;
                            readonly fullName: string | null;
                            readonly landingPageUrl: string | null;
                            readonly socialMediaProfiles: ReadonlyArray<{
                                readonly id: string;
                                readonly link: string | null;
                                readonly platform: {
                                    readonly id: string;
                                    readonly kind: SocialMediaPlatformKind | null;
                                } | null;
                            }> | null;
                            readonly previews: {
                                readonly edges: ReadonlyArray<{
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly responsibility: string | null;
                            readonly description: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type matrixPanelQuery = {
    readonly response: matrixPanelQueryResponse;
    readonly variables: matrixPanelQueryVariables;
};



/*
query matrixPanelQuery(
  $id: ID!
) {
  list(id: $id) {
    hasErrors
    list {
      __typename
      ... on FixedList {
        id
        title
        name
        description
        items {
          count
          edges {
            __typename
            listItem {
              item {
                __typename
                ... on Person {
                  id
                  fullName
                  landingPageUrl
                  socialMediaProfiles {
                    id
                    link
                    platform {
                      id
                      kind
                    }
                  }
                  previews {
                    edges {
                      preview {
                        mediaAsset {
                          files {
                            id
                            name
                            path
                          }
                          id
                        }
                        kind
                      }
                    }
                  }
                  responsibility
                  description
                }
                ... on Node {
                  id
                }
                ... on SearchHit {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
        }
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "socialMediaProfiles",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialMediaProfile",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "link",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "platform",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMediaPlatform",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v11/*: any*/)
      ]
    }
  ]
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "matrixPanelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "previews",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PreviewsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PreviewEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "preview",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Preview",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "mediaAsset",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "MediaAsset",
                                                    "plural": false,
                                                    "selections": [
                                                      (v13/*: any*/)
                                                    ]
                                                  },
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v14/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "matrixPanelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "previews",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PreviewsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PreviewEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "preview",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Preview",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "mediaAsset",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "MediaAsset",
                                                    "plural": false,
                                                    "selections": [
                                                      (v13/*: any*/),
                                                      (v3/*: any*/)
                                                    ]
                                                  },
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v14/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "matrixPanelQuery",
    "id": null,
    "text": "query matrixPanelQuery(\n  $id: ID!\n) {\n  list(id: $id) {\n    hasErrors\n    list {\n      __typename\n      ... on FixedList {\n        id\n        title\n        name\n        description\n        items {\n          count\n          edges {\n            __typename\n            listItem {\n              item {\n                __typename\n                ... on Person {\n                  id\n                  fullName\n                  landingPageUrl\n                  socialMediaProfiles {\n                    id\n                    link\n                    platform {\n                      id\n                      kind\n                    }\n                  }\n                  previews {\n                    edges {\n                      preview {\n                        mediaAsset {\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          id\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  responsibility\n                  description\n                }\n                ... on Node {\n                  id\n                }\n                ... on SearchHit {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '3f2c6e2d7b1041ad475d0c4b5f606bb2';
export default node;
